import { SensorTransport } from './SensorTransportProvider';

// Stub: real implementation lands with Phase 1/5 (WebSocket gateway).
// Keeps the same signature so the page swap is a one-line prop change.
export const webSocketTransport: SensorTransport = {
  useAlarmedBoxes() {
    throw new Error('WebSocketTransport not implemented yet — use polling transport until Phase 5');
  },
  useBoxTimeline() {
    throw new Error('WebSocketTransport not implemented yet');
  },
  useBoxStatus() {
    throw new Error('WebSocketTransport not implemented yet');
  },
};
